const STORAGE_PREFIX = 'gcv.table-settings.';

const storageKey = (tableKey: string) => `${STORAGE_PREFIX}${tableKey}`;

/** Hidden-column ids persisted per table key; [] when missing or malformed. */
export const getHiddenColumns = (tableKey: string): string[] => {
  try {
    const raw = window.localStorage.getItem(storageKey(tableKey));
    if (!raw) {
      return [];
    }
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.every((item) => typeof item === 'string')) {
      return parsed;
    }
    return [];
  } catch {
    return [];
  }
};

export const setHiddenColumns = (tableKey: string, hiddenColumns: string[]): void => {
  try {
    window.localStorage.setItem(storageKey(tableKey), JSON.stringify(hiddenColumns));
  } catch {
    // Best-effort: storage failures must not break the table.
  }
};
